import { Injectable } from '@angular/core';
import { GridsterItem } from 'angular-gridster2';

@Injectable({
  providedIn: 'root'
})
export class DragService {
  private dragData: any = null;

  setDragData(data: any) {
    this.dragData = data;
  }

  getDragData() {
    return this.dragData;
  }

  clearDragData() {
    this.dragData = null;
  }
}
